import React from 'react';
import Tippy from '@tippyjs/react';
import facebook from "@/resources/socialMedia/facebook.svg";
import twitter from "@/resources/socialMedia/twitter.svg";
import linkedin from "@/resources/socialMedia/linkedin.svg";
import instagram from "@/resources/socialMedia/instagram.svg";
import yelp from "@/resources/socialMedia/yelp.svg";
import tiktok from "@/resources/socialMedia/tiktok.svg";

const socialMediaPlatforms = [
  { name: 'facebook', displayName: 'Facebook', icon: facebook },
  { name: 'twitter', displayName: 'Twitter', icon: twitter },
  { name: 'instagram', displayName: 'Instagram', icon: instagram },
  { name: 'linkedin', displayName: 'LinkedIn', icon: linkedin },
  { name: 'yelp', displayName: 'Yelp', icon: yelp },
  { name: 'tiktok', displayName: 'TikTok', icon: tiktok }
];

const SocialLinks = ({ companyEnhancedData }) => {
  return (
    <div className='social-links-container'>
      {socialMediaPlatforms.map(platform => {
        const urlKey = `${platform.name}Url`;
        const platformUrl = companyEnhancedData[urlKey];

        return platformUrl ? (
          <div key={platform.name} className="social-icon-wrapper">
            <a
              href={platformUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="ext-icon-link"
            >
              <Tippy
                key={platform.name}
                content={platform.displayName}
                placement="top"
                theme="dnbtooltip"
              >
                <img src={platform.icon} alt={platform.displayName} className="payment-icon" />
              </Tippy>
            </a>
          </div>
        ) : null;
      })}
    </div>
  );
};

export default SocialLinks;
